import React, { useEffect, useState } from "react";

import { formatHorarioString } from "util/string";

import { useReloadEntityField, useUrlQueryUid2Field } from "components/form";
import DefaultEntityCrud from "components/form/DefaultEntityCrud";
import EntitySearchInput from "components/form/EntitySearch/EntitySearchInput";
import AutocompleteInput from "components/form/input/AutocompleteInput";
import DebugObjComp from "components/DebugObjComp";
import FormContent from "components/form/FormContent";
import SelectInput from "components/form/input/SelectInput";
import TextInput from "components/form/input/TextInput";
import FormRow from "components/form/FormRow";

import SeletorHorarioReuniao from "../SeletorHorarioReuniao";
import PainelAgendaReuniao from "../PainelAgendaReuniao";

import { getReunioes as getReunioesDB, useAllAtiveReunioes } from "entity/Reuniao/funtions";

import InscricaoEntity from "entity/Inscricao";
import ReuniaoEntity from "entity/Reuniao";
import RodadaEntity from "entity/Rodada";

import { Button, CircularProgress, Switch, Typography } from "@mui/material";
import useNotification from "notification";

function ReuniaoFormInter({ setOpen, inscritos, editOnlyP2, reunioes, disabledField = {}, ...props }) {
    const { showWarning, showError } = useNotification();
    const { change } = props.form;

    const { uid, rodada, mesa, inscricao1, inscricao2, horario } = props.values;
    const reunioesMesa = useAllAtiveReunioes(rodada, mesa, reunioes);
    const [lockAgenda, setLockAgenda] = useState(editOnlyP2);
    const [reunioesP1, setReunioesP1] = useState([]);
    const [reunioesP2, setReunioesP2] = useState([]);
    const [loading, setLoading] = useState(false);
    const [firstLoad, setFirstLoad] = useState(true);

    const getReunioes = (uidInscricao) => {
        if (reunioes) {
            return new Promise((resolve, reject) => {
                let reunioesR = [];
                (reunioes || []).forEach((r) => {
                    if (r.inscricao1 && r.inscricao1.uid === uidInscricao) {
                        reunioesR.push(r);
                    }
                    if (r.inscricao2 && r.inscricao2.uid === uidInscricao) {
                        reunioesR.push(r);
                    }
                });
                resolve(reunioesR);
            });
        } else {
            return getReunioesDB(uidInscricao);
        }
    };

    useUrlQueryUid2Field("rodada", "rodada", RodadaEntity, props.form);
    useReloadEntityField(RodadaEntity, "rodada", props, (r) => {
        let mesas = r.mesas;
        if (mesa && mesas) {
            let indexOf = mesas.map((m) => m.uid).indexOf(mesa.uid);
            if (indexOf !== -1) {
                change("mesa", mesas[indexOf]);
            } else {
                change("mesa", "");
            }
        }
    });

    // lógica seletor mesa
    useEffect(() => {
        if (!props.values.mesa) {
            // é a primeira vez que o usuário seleciona as duas inscrições
            if (firstLoad && inscricao1 && inscricao2) {
                setFirstLoad(false);
            }

            // a inscricao1 existe, é do tipo âncora e possui uma mesa
            if (inscricao1 && inscricao1.tipo === "ÂNCORA" && inscricao1.mesa) {
                let auxM = props.values.rodada?.mesas.find((m) => m.uid === inscricao1.mesa.uid);
                if (!editOnlyP2) change("mesa", auxM);
            }
            // só o participante2 é ancora e com mesa
            else if (inscricao2 && inscricao2.tipo === "ÂNCORA" && inscricao2.mesa) {
                let auxM = props.values.rodada?.mesas.find((m) => m.uid === inscricao2.mesa.uid);
                if (!editOnlyP2) change("mesa", auxM);
            }
            // nenhum participante selecionado tem mesa, seja do tipo fornecedor ou ancora
            else {
                // usuario des-selecionou algum participante
                if (!firstLoad) {
                    if (!editOnlyP2) {
                        change("mesa", "");
                    }
                }
                // Verifica se inscricao1 é âncora e não tem mesa
                if (inscricao1 && inscricao1.tipo === "ÂNCORA" && !inscricao1.mesa && inscricao2) {
                    showError("Atribua uma mesa ao Participante 1");
                    change("mesa", "");
                }
                // Verifica se ambas inscricoes não possuem mesa, sendo inscricao1 do tipo fornecedor e inscricao2 do tipo âncora
                else if (
                    inscricao1 &&
                    inscricao1.tipo === "FORNECEDOR" &&
                    inscricao2 &&
                    inscricao2.tipo === "ÂNCORA" &&
                    !inscricao2.mesa
                ) {
                    showError("Atribua uma mesa ao Participante 2");
                    change("mesa", "");
                }
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [inscricao2, inscricao1]);

    // previne reunião duplicada
    useEffect(() => {
        if (inscricao2) {
            // procura as reuniões da inscrição2
            getReunioes(inscricao2.uid).then((r) => {
                // procura se inscrição 1 já tem uma reunião no mesmo horário
                let horario = r.find((ri) => ri.horario?.horario === props.values.horario?.horario);

                // já tem reuniao nesse horário, entao desmarca o horario do dialog de encaixe
                console.log("horario", horario);
                if (horario) {
                    if (uid !== horario.uid) {
                        if (editOnlyP2) {
                            change("inscricao2", null);
                        } else {
                            change("horario", null);
                        }
                        showWarning(
                            inscricao2.empresa.nomeFantasia + " já possui reunião agendada para " + horario.horariotxt
                        );
                    }
                }
                if (inscricao1) {
                    // procura se já tem alguma reunião da inscrição2 com a inscrição1
                    let find = r.find(
                        (ri) => ri.inscricao1.uid === inscricao1.uid || ri.inscricao2.uid === inscricao1.uid
                    );

                    // só tá editando a reunião já marcada
                    if (uid === find?.uid) {
                        find = false;
                    }

                    if (find) {
                        showWarning(
                            inscricao2.empresa.nomeFantasia +
                                " já possui reunião agendada com esta empresa: " +
                                find.mesa.name +
                                " - " +
                                find.horariotxt
                        );
                        change("inscricao2", null);
                        setReunioesP2([]);
                    } else {
                        setReunioesP2(r);
                    }
                } else {
                    setReunioesP2(r);
                }
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [inscricao2]);

    // também previne reunião duplicada
    useEffect(() => {
        if (inscricao1) {
            // procura as reuniões da inscrição1
            getReunioes(inscricao1.uid).then((r) => {
                // procura se inscrição 1 já tem uma reunião no mesmo horário
                let horario = r.find((ri) => ri.horario?.horario === props.values.horario?.horario);

                // já tem reuniao nesse horário, entao desmarca o horario do dialog de encaixe
                if (horario) {
                    if (uid !== horario.uid) {
                        if (editOnlyP2) {
                            change("inscricao1", null);
                        } else {
                            change("horario", null);
                        }
                        showWarning(
                            inscricao1.empresa.nomeFantasia + " já possui reunião agendada para " + horario.horariotxt
                        );
                    }
                }

                if (inscricao2) {
                    // procura se já tem alguma reunião da inscrição2 com a inscrição1
                    let find = r.find(
                        (ri) => ri.inscricao1.uid === inscricao2.uid || ri.inscricao2.uid === inscricao2.uid
                    );

                    // só tá editando a reunião já marcada
                    if (uid === find?.uid) {
                        find = false;
                    }

                    if (find) {
                        showWarning(
                            inscricao1.empresa.nomeFantasia +
                                " já possui reunião agendada com esta empresa: " +
                                find.mesa.name +
                                " - " +
                                find.horariotxt
                        );
                        change("inscricao1", null);
                        setReunioesP1([]);
                    } else {
                        setReunioesP1(r);
                    }
                } else {
                    setReunioesP1(r);
                }
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [inscricao1]);

    // verifica se rodada está acontecendo
    const isRodadaHappening = () => {
        if (rodada) {
            let dataRodadaInicio = rodada.dataInicio;
            let dataRodadaFinal = rodada.dataFinal;
            let dateToday = new Date();
            var userTimezoneOffset = dateToday.getTimezoneOffset() * 60000;
            dateToday = new Date(dateToday.getTime() - userTimezoneOffset);

            let isoTotay = dateToday.toISOString().substring(0, 16);

            if (isoTotay >= dataRodadaInicio && isoTotay <= dataRodadaFinal) {
                return true;
            } else {
                return false;
            }
        } else {
            return false;
        }
    };

    const queryP1 = (query) => {
        query = query.where("rodada.uid", "==", rodada.uid);
        query = query.where("status", "==", "INSCRITO");

        if (isRodadaHappening()) {
            console.log("esta");
            // query = query.where("status", "==", "INSCRITO")
            query = query.where("statusEvento", "==", "PRESENTE");
            // } else {
            //   query = query.where("status", "!=", "CANCELADO")
            //   query = query.where("statusEvento", "in", ["INSCRITO", "PRESENTE"])
        }

        if (inscricao2) {
            query = query.where("uid", "!=", inscricao2.uid);
        }

        return query;
    };

    // lógica seletor PARTICIPANTE 2: somente ápitos para agendamento
    const queryP2 = (query) => {
        query = query.where("rodada.uid", "==", rodada.uid);
        query = query.where("status", "==", "INSCRITO");

        if (isRodadaHappening()) {
            // query = query.where("status", "==", "INSCRITO")
            query = query.where("statusEvento", "==", "PRESENTE");
            // } else {
            //   query = query.where("status", "!=", "CANCELADO")
            //   query = query.where("statusEvento", "in", ["INSCRITO", "PRESENTE"])
        }

        if (inscricao1) {
            query = query.where("uid", "!=", inscricao1.uid);
        }

        return query;
    };

    // lógica seletor RODADA: somente ativas
    const queryR = (query) => {
        query = query.where("status", "==", "ATIVO");
        return query;
    };

    // lógica de seleção de horário (horário ficar ver ao selecionar e etc)
    const selectHorario = (horario) => {
        change("horario", horario);
        change("horariotxt", formatHorarioString(horario.horario));
    };

    // let showMesa1 = (inscricao1 && inscricao2 && inscricao1.tipo === "ÂNCORA")
    //   // os dois são fornecedores
    //   || (!mesa && inscricao1 && inscricao2 && inscricao2.tipo !== "ÂNCORA")
    //   // a mesa é da inscricao1
    //   || (mesa && mesa.uid && mesa.uid === inscricao1?.mesa?.uid)

    return (
        <FormContent sx={{ m: 1 }}>
            <FormRow>
                <SelectInput sx={{ flex: 0.5 }} name="status" label="Status" options={["ATIVO", "INATIVO"]} required />
                <EntitySearchInput
                    name="rodada"
                    label="Rodada"
                    EntityClass={RodadaEntity}
                    extraQuery={queryR}
                    disabled
                    required
                />
            </FormRow>
            <FormRow>
                <EntitySearchInput
                    name="inscricao1"
                    label="Participante 1"
                    EntityClass={InscricaoEntity}
                    extraQuery={queryP1}
                    specificColumns={[
                        { field: "empresa.nomeFantasia", headerName: "NOME DA EMPRESA", flex: 2, filter: true },
                        { field: "tipo", headerName: "TIPO DE INSCRIÇÃO", flex: 0.65, filter: true },
                    ]}
                    addFields={["tipo", "statusEvento"]}
                    disabled={rodada ? disabledField["inscricao1"] : true}
                    // helperText={isRodadaHappening() ? "Somente Participantes Presentes" : "Somente Participantes Inscritos"}
                    helperText={isRodadaHappening() ? "Somente Participantes Presentes" : ""}
                    required
                />

                <AutocompleteInput
                    name="mesa"
                    label="Mesa"
                    // disabled={rodada && (rodada.tipoAncora === "Comprador" || rodada.tipoAncora === "Vendedor")}

                    options={rodada?.mesas || []}
                    required
                    getOptionLabel={(option) => option.name || ""}
                    isOptionEqualToValue={(option, value) => option.uid === value.uid}
                    // desabilitando mesas de ancoras no seletor
                    getOptionDisabled={(mesaOption) => {
                        let mesasAncoras = (inscritos || [])
                            .filter((i) => i.statusEvento !== "AUSENTE" && i.mesa)
                            .map((i) => i.mesa);

                        if (mesasAncoras.find((m) => m.uid === mesaOption.uid)) {
                            return true;
                        }
                        return false;
                    }}
                />
            </FormRow>
            <FormRow>
                <EntitySearchInput
                    name="inscricao2"
                    label="Participante 2"
                    EntityClass={InscricaoEntity}
                    extraQuery={queryP2}
                    specificColumns={[
                        { field: "empresa.nomeFantasia", headerName: "NOME DA EMPRESA", flex: 2, filter: true },
                        { field: "tipo", headerName: "TIPO DE INSCRIÇÃO", flex: 0.65, filter: true },
                    ]}
                    addFields={["tipo", "statusEvento"]}
                    disabled={rodada ? disabledField["inscricao2"] : true}
                    // helperText={isRodadaHappening() ? "Somente Participantes Presentes" : "Somente Participantes Inscritos"}
                    helperText={isRodadaHappening() ? "Somente Participantes Presentes" : ""}
                    required
                />
            </FormRow>
            <FormRow>
                <TextInput name="obs" label="Obs" multiline />
            </FormRow>
            <div style={{ display: "flex", justifyContent: "center", flex: 1 }}>
                {loading ? (
                    <CircularProgress />
                ) : (
                    <Button
                        onClick={() => {
                            setLoading(true);

                            const myPromise = new Promise((resolve, reject) => {
                                let s = props.form.submit();
                                if (s) {
                                    resolve("Sucesso!");
                                    if (editOnlyP2) {
                                        setOpen(false);
                                    }
                                } else {
                                    reject("O Submit Falhou!");
                                }
                            });

                            myPromise
                                .then((successMessage) => {
                                    console.log(`Aweee! ${successMessage}`);
                                    setLoading(false);
                                    setOpen(false);
                                })
                                .catch((err) => {
                                    console.log(`Ops! ${err}`);
                                    setLoading(false);
                                });
                        }}
                    >
                        Adicionar Reunião
                    </Button>
                )}
            </div>
            <FormRow>
                <SeletorHorarioReuniao uidReuniao={uid} rodada={rodada} mesa={mesa} />
                {editOnlyP2 && (
                    <div style={{ paddingLeft: 25, display: "flex", alignItems: "center" }}>
                        <Switch checked={!lockAgenda} onChange={(b) => setLockAgenda(!lockAgenda)} />
                        <Typography>Mudar Horário</Typography>
                    </div>
                )}
            </FormRow>
            {!lockAgenda && (
                <FormRow>
                    {rodada && mesa && (
                        <PainelAgendaReuniao
                            rodada={rodada}
                            onClick={selectHorario}
                            atualValue={horario}
                            reuniaoAtual={props.values}
                            reunioes={(reunioesMesa || []).concat(reunioesP2).concat(reunioesP1 || [])}
                            mesa={mesa}
                        />
                    )}
                </FormRow>
            )}

            <DebugObjComp colection={ReuniaoEntity.collectionUID} uidObj={props.values.uid} values={props.values} />
        </FormContent>
    );
}

export default function DialogReuniaoForm({
    setOpen,
    rodada,
    inscritos,
    initialValues,
    editOnlyP2,
    overSave,
    ...outerprops
}) {
    console.log("overSaveReuniao", overSave);
    const preValid = (obj) => {};
    return (
        <DefaultEntityCrud
            EntityClass={ReuniaoEntity}
            title={rodada ? "Painel de Controle - " + rodada.nome : "Painel de Controle"}
            formActions={{ novoForm: false, salvarForm: false, sairForm: false }}
            initialValuesStart={initialValues}
            setOpen={setOpen.setOpen}
            preValid={preValid}
            overSave={overSave}
        >
            {(props) => {
                return (
                    <ReuniaoFormInter
                        editOnlyP2={editOnlyP2}
                        setOpen={setOpen}
                        inscritos={inscritos}
                        {...outerprops}
                        {...props}
                    />
                );
            }}
        </DefaultEntityCrud>
    );
}
